import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b44deec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-new" }
const _hoisted_2 = { class: "home-new__drawer-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<section class=\"hero-section\" data-v-3b44deec><div class=\"hero-content\" data-v-3b44deec><h1 class=\"hero-title\" data-v-3b44deec> We design and build digital platforms, products, and ecosystems for modern businesses </h1><div class=\"hero-copy\" data-v-3b44deec><div class=\"hero-subtitle\" data-v-3b44deec> Shanghai-based digital product and technology company working with global companies across China and Asia. </div><div class=\"hero-subtitle\" data-v-3b44deec> We design, build, and scale digital platforms, systems, and AI-powered products. </div></div></div></section>", 1)
const _hoisted_4 = { class: "clients-section" }
const _hoisted_5 = { class: "work-section" }
const _hoisted_6 = { class: "work-tabs-wrapper" }
const _hoisted_7 = { class: "work-tabs" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "work-featured"
}
const _hoisted_10 = { class: "project-item project-item--featured" }
const _hoisted_11 = { class: "project-card-media" }
const _hoisted_12 = { class: "project-info" }
const _hoisted_13 = { class: "project-title" }
const _hoisted_14 = { class: "project-client" }
const _hoisted_15 = {
  key: 0,
  class: "project-type"
}
const _hoisted_16 = { class: "work-grid" }
const _hoisted_17 = { class: "project-card-media" }
const _hoisted_18 = { class: "project-info" }
const _hoisted_19 = { class: "project-title" }
const _hoisted_20 = { class: "project-client" }
const _hoisted_21 = {
  key: 0,
  class: "project-type"
}
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<section class=\"solutions-section\" data-v-3b44deec><div class=\"solutions-header\" data-v-3b44deec><p class=\"solutions-label\" data-v-3b44deec>OUR SOLUTIONS</p><h2 class=\"solutions-title\" data-v-3b44deec> We design, build, and govern digital platforms, products, and systems. </h2><p class=\"solutions-title\" data-v-3b44deec> Through strategy, creativity, engineering, and AI, we help organizations scale the technology their future depends on. </p></div></section>", 1)
const _hoisted_23 = { class: "solutions-grid-section" }
const _hoisted_24 = { class: "solutions-grid" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "solution-title" }, "Platforms", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "solution-description" }, " Enterprise platforms, portals, dashboards, and CRMs that support operations across the organization and connect employees, partners, customers, systems, and data. ", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "solution-title" }, "Products", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "solution-description" }, " Digital products, including mobile apps, mini programs, SaaS products, and connected device applications, that focus on usability, scalability, and long-term product evolution. ", -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "solution-title" }, "Commerce", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "solution-description" }, " Commerce platforms for e-commerce, retail, membership, and loyalty across web, mobile, and China ecosystems including WeChat, Tmall, JD, and RedNote. ", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "solution-title" }, "AI", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "solution-description" }, " AI solutions including strategy, automation, intelligent assistants, data systems, and AI-powered products and platforms that improve operations and customer experiences. ", -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "solution-title" }, "Systems", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "solution-description" }, " System architecture, integrations, APIs, and platform modernization programs that connect systems, improve data flow, and evolve enterprise technology environments. ", -1))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "solution-title" }, "China Tech", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "solution-description" }, " Digital platforms, ecosystems, server infrastructure, and compliance-ready technology solutions that enable organizations to operate and scale successfully in China. ", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "capabilities-section" }
const _hoisted_44 = { class: "capabilities-content" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "capabilities-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "capabilities-label" }, "OUR CAPABILITIES"),
  /*#__PURE__*/_createElementVNode("h2", { class: "capabilities-title" }, " End-to-end capabilities across strategy, design, engineering, and AI ")
], -1))
const _hoisted_46 = { class: "capabilities-list" }
const _hoisted_47 = { class: "capability-title" }
const _hoisted_48 = { class: "capability-description" }
const _hoisted_49 = /*#__PURE__*/_createStaticVNode("<section class=\"who-section-wrapper\" data-v-3b44deec><div class=\"who-section\" data-v-3b44deec><p class=\"who-label\" data-v-3b44deec>WHO WE ARE</p><h2 class=\"who-title\" data-v-3b44deec> We design for China<br data-v-3b44deec>and global markets </h2><p class=\"who-description\" data-v-3b44deec> Our team is based in Shanghai and works with global companies building for China and Chinese companies expanding to global markets We combine global product thinking with deep knowledge of platforms, users, and digital ecosystems in China and around the world. </p></div></section><section class=\"video-section\" data-v-3b44deec><div class=\"video-container\" data-v-3b44deec><div class=\"video-wrapper\" data-v-3b44deec><div class=\"video-placeholder\" data-v-3b44deec><button class=\"video-play-button\" data-v-3b44deec><svg width=\"64\" height=\"64\" viewBox=\"0 0 64 64\" fill=\"none\" data-v-3b44deec><circle cx=\"32\" cy=\"32\" r=\"32\" fill=\"white\" data-v-3b44deec></circle><path d=\"M26 22L42 32L26 42V22Z\" fill=\"black\" data-v-3b44deec></path></svg></button></div></div></div></section><div class=\"compliance-drawer\" data-v-3b44deec><section class=\"compliance-section\" data-v-3b44deec><div class=\"compliance-content\" data-v-3b44deec><p class=\"compliance-label\" data-v-3b44deec>SECURITY &amp; COMPLIANCE</p><div class=\"compliance-header\" data-v-3b44deec><div data-v-3b44deec><h2 class=\"compliance-title\" data-v-3b44deec>Compliance by design</h2><p class=\"compliance-description\" data-v-3b44deec> Security, compliance, and data protection are built into every platform and system we design from the start. </p><ul class=\"compliance-list\" data-v-3b44deec><li data-v-3b44deec>ISO 27001 Certified</li><li data-v-3b44deec>ISO 9001 Certified</li><li data-v-3b44deec>PIPL Compliant</li><li data-v-3b44deec>MLPS Ready</li><li data-v-3b44deec>ICP Licensing Support</li></ul></div><div class=\"compliance-badges\" data-v-3b44deec><div class=\"badge-item\" data-v-3b44deec><img src=\"/assets/icons/iso27001.svg\" alt=\"ISO 27001 Certified\" class=\"badge-image\" data-v-3b44deec><p class=\"badge-text\" data-v-3b44deec>Information security and data protection standards</p></div><div class=\"badge-item\" data-v-3b44deec><img src=\"/assets/icons/iso9001.svg\" alt=\"ISO 9001 Certified\" class=\"badge-image\" data-v-3b44deec><p class=\"badge-text\" data-v-3b44deec>Quality management and process standards</p></div></div></div></div></section><section class=\"cta-section\" data-v-3b44deec><h2 class=\"cta-title\" data-v-3b44deec>We usually get called when things get complicated</h2><p class=\"cta-subtitle\" data-v-3b44deec>Time to make your complex experiences feel simple?</p><button class=\"cta-button\" data-v-3b44deec>Request a Proposal</button></section></div>", 3)
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<footer class=\"footer-section\" data-v-3b44deec><div class=\"footer-content\" data-v-3b44deec><div class=\"footer-column\" data-v-3b44deec><h4 class=\"footer-heading\" data-v-3b44deec>COMPANY</h4><ul class=\"footer-links\" data-v-3b44deec><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Who We Are</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Insights</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Contact</a></li></ul></div><div class=\"footer-column\" data-v-3b44deec><h4 class=\"footer-heading\" data-v-3b44deec>SOLUTIONS</h4><ul class=\"footer-links\" data-v-3b44deec><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Platforms</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Products</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Commerce</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>AI</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Systems</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>China Tech</a></li></ul></div><div class=\"footer-column\" data-v-3b44deec><h4 class=\"footer-heading\" data-v-3b44deec>CAPABILITIES</h4><ul class=\"footer-links\" data-v-3b44deec><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Strategy</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>User Research</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Product Design</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Engineering</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>AI &amp; Data</a></li><li data-v-3b44deec><a href=\"#\" data-v-3b44deec>Security &amp; Compliance</a></li></ul></div><div class=\"footer-column\" data-v-3b44deec><h4 class=\"footer-heading\" data-v-3b44deec>CONTACT</h4><p class=\"footer-address\" data-v-3b44deec>No. 28 Jiangyao Road, Lab 902,<br data-v-3b44deec>Building T2, Qiantan, Pudong New<br data-v-3b44deec>Area, Shanghai, China</p><p class=\"footer-phone\" data-v-3b44deec>+86 (21) 2027 0599</p><p class=\"footer-email\" data-v-3b44deec>hello@digitalcreative.asia</p><p class=\"footer-social\" data-v-3b44deec>LinkedIn</p></div></div><div class=\"footer-bottom\" data-v-3b44deec><div class=\"footer-logo\" data-v-3b44deec><img src=\"/assets/icons/dca-logo.svg\" alt=\"DCA Logo\" class=\"logo-icon\" data-v-3b44deec></div><p class=\"footer-copyright\" data-v-3b44deec>© 2026 - Digital Creative Asia 星山网络科技（上海）有限公司 / 沪ICP备19005446号-1</p><div class=\"footer-legal\" data-v-3b44deec><a href=\"#\" data-v-3b44deec>Privacy Policy</a><a href=\"#\" data-v-3b44deec>Terms</a><a href=\"#\" data-v-3b44deec>Trust Center</a></div></div></footer>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PartnersNew = _resolveComponent("PartnersNew")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_ClippingAnimation = _resolveComponent("ClippingAnimation")!
  const _component_CustomCursor = _resolveComponent("CustomCursor")!
  const _component_Anchor = _resolveComponent("Anchor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_PartnersNew)
      ]),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: tab.id,
                class: _normalizeClass([ 'tab-button', { 'active': _ctx.activeTab === tab.id } ]),
                onClick: ($event: any) => (_ctx.activeTab = tab.id)
              }, _toDisplayString(tab.label), 11, _hoisted_8))
            }), 128))
          ])
        ]),
        (_ctx.featuredProject)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Anchor, {
                  disabled: _ctx.featuredProject.coming_soon,
                  route: {
                        name: _ctx.Route.CaseStudy,
                        meta: { theme: _ctx.featuredProject?.theme?.value === 'dark' ? _ctx.Theme.Dark : _ctx.Theme.Default },
                        params: {
                            slug: _ctx.featuredProject.slug,
                            gradient: _ctx.featuredProject?.list_cover?.gradient_background ?? _ctx.featuredProject?.cover?.gradient_background ?? 'linear-gradient(140deg, #424242, #121212)',
                        },
                    },
                  class: "project-card-link"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_CustomCursor, {
                        text: _ctx.featuredProject.coming_soon ? 'Coming Soon' : 'View'
                      }, {
                        default: _withCtx(({ eventListeners }) => [
                          _createVNode(_component_ClippingAnimation, { interactive: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Picture, _mergeProps({
                                image: _ctx.featuredProject?.list_cover,
                                width: "100%",
                                height: "100%",
                                cover: ""
                              }, eventListeners), null, 16, ["image"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 1
                      }, 8, ["text"])
                    ])
                  ]),
                  _: 1
                }, 8, ["disabled", "route"]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Anchor, {
                    disabled: _ctx.featuredProject.coming_soon,
                    route: {
                            name: _ctx.Route.CaseStudy,
                            params: {
                                slug: _ctx.featuredProject.slug,
                                gradient: _ctx.featuredProject?.list_cover?.gradient_background ?? _ctx.featuredProject?.cover?.gradient_background ?? 'linear-gradient(140deg, #424242, #121212)'
                            }
                        }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.featuredProject.title), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "route"]),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.featuredProject.client_name), 1),
                  (_ctx.featuredProject.tags)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.featuredProject.tags.join(' / ')), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remainingProjects, (project) => {
            return (_openBlock(), _createElementBlock("div", {
              key: project.id,
              class: "project-item"
            }, [
              _createVNode(_component_Anchor, {
                disabled: project.coming_soon,
                route: {
                        name: _ctx.Route.CaseStudy,
                        meta: { theme: project?.theme?.value === 'dark' ? _ctx.Theme.Dark : _ctx.Theme.Default },
                        params: {
                            slug: project.slug,
                            gradient: project?.list_cover?.gradient_background ?? project?.cover?.gradient_background ?? 'linear-gradient(140deg, #424242, #121212)',
                        },
                    },
                class: "project-card-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_CustomCursor, {
                      text: project.coming_soon ? 'Coming Soon' : 'View'
                    }, {
                      default: _withCtx(({ eventListeners }) => [
                        _createVNode(_component_ClippingAnimation, { interactive: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Picture, _mergeProps({
                              image: project?.list_cover,
                              width: "100%",
                              height: "100%",
                              cover: ""
                            }, eventListeners), null, 16, ["image"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ])
                ]),
                _: 2
              }, 1032, ["disabled", "route"]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Anchor, {
                  disabled: project.coming_soon,
                  route: {
                            name: _ctx.Route.CaseStudy,
                            params: {
                                slug: project.slug,
                                gradient: project?.list_cover?.gradient_background ?? project?.cover?.gradient_background ?? 'linear-gradient(140deg, #424242, #121212)'
                            }
                        }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_19, _toDisplayString(project.title), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "route"]),
                _createElementVNode("p", _hoisted_20, _toDisplayString(project.client_name), 1),
                (project.tags)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(project.tags.join(' / ')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _hoisted_22,
      _createElementVNode("section", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "solution-card" }, eventListeners), _hoisted_27, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "solution-card" }, eventListeners), _hoisted_30, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "solution-card" }, eventListeners), _hoisted_33, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "solution-card" }, eventListeners), _hoisted_36, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "solution-card" }, eventListeners), _hoisted_39, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "solution-card" }, eventListeners), _hoisted_42, 16)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capabilities, (capability) => {
              return (_openBlock(), _createBlock(_component_CustomCursor, {
                key: capability.title,
                text: "View"
              }, {
                default: _withCtx(({ eventListeners }) => [
                  _createElementVNode("div", _mergeProps({ class: "capability-item" }, eventListeners), [
                    _createElementVNode("h3", _hoisted_47, _toDisplayString(capability.title), 1),
                    _createElementVNode("p", _hoisted_48, _toDisplayString(capability.description), 1)
                  ], 16)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ])
      ]),
      _hoisted_49
    ]),
    _hoisted_52
  ]))
}